import addSubMenu from '../../../../../actions/shop/menu/addSubMenu';

async function submit(values, dispatch) {
     await dispatch(addSubMenu(values));
}

export default submit;